import { render } from "./PantalladeCarga.vue?vue&type=template&id=1b8fd48e&scoped=true"
import script from "./PantalladeCarga.vue?vue&type=script&lang=js"
export * from "./PantalladeCarga.vue?vue&type=script&lang=js"

import "./PantalladeCarga.vue?vue&type=style&index=0&id=1b8fd48e&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8fd48e"]])

export default __exports__